import ACTIONS from '~shared/actions';
import { Grow2529StateType } from './types';
import { Packages } from '~shared/constants/pricing';
import { CombinedActions } from '~shared/types/pricing/actions';

export const grow2529State: Grow2529StateType = {
  toggleChecked: [Packages.FormsAnnual, Packages.StarterAnnual],
};

export default function Grow2529Reducer(state: Grow2529StateType, action: CombinedActions): Grow2529StateType {
  if (action.type === ACTIONS.FORMS_TOGGLE_SWITCH) {
    const newState = state.toggleChecked.filter(pkg => pkg !== action.payload.packageToBeReplaced);
    newState.push(action.payload.replacedWith);

    return {
      ...state,
      toggleChecked: newState,
    };
  }

  if (action.type === ACTIONS.FORMS_RESET_TOGGLE_SWITCH) {
    return {
      ...state,
      toggleChecked: [Packages.FormsAnnual, Packages.StarterAnnual],
    };
  }

  return state;
}
